import Gtm from '@grebban/gtm';

export default () => {
    Gtm.addDataLayerEvent('page_error', {});
}